import { Grid, styled } from "@mui/material";
import React, { useState } from "react";
import BgImage from "../../assets/bg5.jpg";
import Reports from "./Reports";
import MasterData from "./MasterData";
import TransactionEditing from "./TransactionEditing";
import UserPermission from "./UserPermission";
import DialogModal from "../../components/Dialog";
import useAuth from "../../hooks/useAuth";
import BarcodeGeneration from "./BarcodeGeneration";
import BarcodeReturnMaterial from "./BarcodeReturnMaterial";
import AccessManagement from "./AccessManagement";
import BarcodeNonReturnable from "./BarcodeNonReturnable";

const DashboardWrapper = styled(Grid)`
  padding: 30px 80px;
  background: #fff;
  min-height: 80vh;
`;

const Card = styled(Grid)`
  border: 1px solid #000;
  border-radius: 15px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  background: #fff;
  height: 250px;
  box-shadow: 1px 1px rgba(16, 24, 40, 0.12);
  transition: box-shadow 0.4s ease;
  transition: background-color 0.4s ease;
  
  &:hover {
    border: 1px solid #D9D9D9;
    background-color: #F0F0F0;
    box-shadow: 1px 1px rgba(16, 24, 40, 0.2);
  }
`;

function Dashboard() {
  const [modelToggle, setModelToggle] = useState(false);
  const [moduleType, setModuleType] = useState("");
  const { auth } = useAuth();

  const transactionRoles = ["superadmin", "ERP MANAGER"];

  const adminRoles = ["superadmin", "ERP MANAGER"];

  const showOnlyAdmin = adminRoles.some((val) => auth?.roles.includes(val));

  const showAdminAccess = transactionRoles.some((val) =>
    auth?.roles.includes(val)
  );

  const barcodeRoles = ["GENERATE BILLING", "superadmin", "DESPATCH INCHARGE"];

  // const returableRoles = ["STORE KEEPER", "superadmin", "ERP MANAGER"];

  const showBarcodeGeneration = barcodeRoles.some((val) =>
    auth?.roles.includes(val)
  );

  const reportsRoles = [
    "superadmin",
    "ERP MANAGER",
    "FACTORY MANAGER",
    "PRODUCTION MANAGER",
    "DGM",
    "HR MANAGER",
    "PURCHASE MANAGER",
    "ACCOUNTS_MANAGER",
    "FINANCE_MANAGER",
    "ELECTRICAL_MANAGER",
    "MECHANICAL_MANAGER",
    "STORE_MANAGER",
    "DESPATCH MANAGER",
    "RAW MATREIAL INCHARGE",
    "CANTEEN INCHARGE"
  ];

  const showReportsRoles = reportsRoles.some((val) =>
    auth?.roles.includes(val)
  );

  return (
    <DashboardWrapper
      container
      justifyContent={"center"}
      columnGap={10}
      rowGap={3}
      style={{
        backgroundImage: `url(${BgImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      {showReportsRoles && (
        <Card
          item
          container
          xs={3}
          justifyContent={"center"}
          alignItems={"center"}
          onClick={() => {
            setModelToggle(true);
            setModuleType("REPORTS");
          }}
        >
          {" "}
          <Grid item xs={12}>
            Reports
          </Grid>
        </Card>
      )}

      {showAdminAccess && (
        <Card
          item
          container
          xs={3}
          justifyContent={"center"}
          alignItems={"center"}
          onClick={() => {
            setModelToggle(true);
            setModuleType("MASTER_DATA");
          }}
        >
          {/* <img src={GuestImage} alt="guest" height={50} width={50} /> */}
          <Grid item xs={12}>
            Master Data Editing
          </Grid>
        </Card>
      )}
      {showAdminAccess && (
        <Card
          item
          container
          xs={3}
          justifyContent={"center"}
          alignItems={"center"}
          onClick={() => {
            setModelToggle(true);
            setModuleType("TRANSACTION_EDITING");
          }}
        >
          <Grid item xs={12}>
            Transaction Editing
          </Grid>
        </Card>
      )}
      {showBarcodeGeneration && (
        <Card
          item
          container
          xs={3}
          justifyContent={"center"}
          alignItems={"center"}
          onClick={() => {
            setModelToggle(true);
            setModuleType("BARCODE_GENERATION");
          }}
        >
          <Grid item xs={12}>
            Barcode Generation
          </Grid>
        </Card>
      )}
      {showBarcodeGeneration && (
        <Card
          item
          container
          xs={3}
          justifyContent={"center"}
          alignItems={"center"}
          onClick={() => {
            setModelToggle(true);
            setModuleType("BARCODE_NON_RETURNABLE");
          }}
        >
          <Grid item xs={12}>
            Scan Barcode For Non Return Material
          </Grid>
        </Card>
      )}
      {showBarcodeGeneration && (
        <Card
          item
          container
          xs={3}
          justifyContent={"center"}
          alignItems={"center"}
          onClick={() => {
            setModelToggle(true);
            setModuleType("BARCODE_RETURNABLE");
          }}
        >
          <Grid item xs={12}>
            Scan Barcode For Returnable Material
          </Grid>
        </Card>
      )}

      {showOnlyAdmin && (
        <Card
          item
          container
          xs={3}
          justifyContent={"center"}
          alignItems={"center"}
          onClick={() => {
            setModelToggle(true);
            setModuleType("ACCESS_MANAGEMENT");
          }}
        >
          <Grid item xs={12}>
            Access Management
          </Grid>
        </Card>
      )}

      <DialogModal
        DialogModal
        toggleModal={modelToggle}
        setToggleModal={setModelToggle}
      >
        {(() => {
          switch (moduleType) {
            case "REPORTS":
              return <Reports setModelToggle={setModelToggle} />;
            case "MASTER_DATA":
              return <MasterData setModelToggle={setModelToggle} />;
            case "TRANSACTION_EDITING":
              return <TransactionEditing setModelToggle={setModelToggle} />;
            case "BARCODE_GENERATION":
              return <BarcodeGeneration setModelToggle={setModelToggle} />;
            case "BARCODE_RETURNABLE":
              return (
                <BarcodeReturnMaterial
                  type={"BARCODE_RETURNABLE"}
                  setModelToggle={setModelToggle}
                />
              );
            case "BARCODE_NON_RETURNABLE":
              return <BarcodeNonReturnable setModelToggle={setModelToggle} />;
            case "ACCESS_MANAGEMENT":
              return <AccessManagement setModelToggle={setModelToggle} />;
            default:
              return <UserPermission setModelToggle={setModelToggle} />;
          }
        })()}
      </DialogModal>
    </DashboardWrapper>
  );
}

export default Dashboard;
